var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import HttpClient from "./config/httpClient.js";
import axios from "axios";
import createHubSpotData from "./utils/createHubSpotData";
import MappyAPI from "./mappy/mappy";
import VeritasAPI from "./veritas/veritas";
class RBAPI {
    constructor(roadwayAPIBaseURL, loginURL, firebaseInstance) {
        this.httpClient = new HttpClient(roadwayAPIBaseURL, loginURL, firebaseInstance);
        this.roadwayAPIBaseURL = roadwayAPIBaseURL;
        this.firebase = firebaseInstance;
    }
    fetchScansByUser(userUId, assessmentType = null, shouldEmptyOrgsBeFiltered = true) {
        return __awaiter(this, void 0, void 0, function* () {
            let dataFetchURL = `/users/${userUId}/scans/`;
            if (assessmentType && shouldEmptyOrgsBeFiltered) {
                dataFetchURL += `?assessmentType=${assessmentType}&shouldEmptyOrgsBeFiltered=${shouldEmptyOrgsBeFiltered}`;
            }
            else if (shouldEmptyOrgsBeFiltered) {
                dataFetchURL += `?shouldEmptyOrgsBeFiltered=${shouldEmptyOrgsBeFiltered}`;
            }
            else if (assessmentType) {
                dataFetchURL += `?assessmentType=${assessmentType}`;
            }
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    getOrganizationUsers(organizationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/organizations/${organizationId}/users`;
            const dataFetchResoponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResoponse.data.data;
        });
    }
    // we don't use this
    getUserOrganizations(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/users/${uid}/organizations`;
            const dataFetchResoponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResoponse.data.data;
        });
    }
    fetchLayersByScan(scanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/scans/${scanId}/layers`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    fetchScan(scanId) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!scanId)
                throw Error("scanId is undefined");
            const dataFetchURL = `/scans/${scanId}`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    fetchScanStreetAnalysis(scanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/scans/${scanId}/streetanalysis`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    fetchScanNetworkAnalysis(scanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/scans/${scanId}/networkAnalysis`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    fetchScanSegments(scanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/scans/${scanId}/segments`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    updateUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataUpdateURL = `/users/${user.id}`;
            const dataUpdateResponse = yield this.httpClient.service.patch(dataUpdateURL, user);
            return dataUpdateResponse.data;
        });
    }
    deleteUser(user, organizationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataDeleteURL = `/users/${user.id}/organization/${organizationId}`;
            const dataDeleteResponse = yield this.httpClient.service.delete(dataDeleteURL, user);
            return dataDeleteResponse.data;
        });
    }
    inviteUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiURL = `/users/invite`;
            const dataUpdateResponse = yield this.httpClient.service.post(apiURL, user);
            return dataUpdateResponse.data;
        });
    }
    createUser(user) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiURL = `/users/create`;
            const dataUpdateResponse = yield this.httpClient.service.post(apiURL, user);
            return dataUpdateResponse.data;
        });
    }
    validateInvite(token) {
        return __awaiter(this, void 0, void 0, function* () {
            const apiURL = `/users/invite/validate/${token}/`;
            const validateResponse = yield this.httpClient.service.get(apiURL, {
                noAuth: true,
            });
            return validateResponse.data;
        });
    }
    getUser(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataGetURL = `/users/${userId}`;
            const dataGetResponse = yield this.httpClient.service.get(dataGetURL);
            return dataGetResponse.data.data;
        });
    }
    checkIfUserHasPasswordByEmail(email) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataGetURL = `/users/${email}/has-password`;
            const dataGetResponse = yield axios.get(dataGetURL);
            return dataGetResponse.data;
        });
    }
    getUserBoundsState(userId, scanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataGetURL = `/users/${userId}/preferences/scans/${scanId}/bounds`;
            const dataGetResponse = yield this.httpClient.service.get(dataGetURL);
            return dataGetResponse.data.data;
        });
    }
    updateUserBoundsState(userId, scanId, scanState) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataUpdateURL = `/users/${userId}/preferences/scans/${scanId}/bounds`;
            const dataUpdateResponse = yield this.httpClient.service.patch(dataUpdateURL, scanState);
            return dataUpdateResponse.data.data;
        });
    }
    getUserLayerState(userId, scanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataGetURL = `/users/${userId}/preferences/scans/${scanId}/layers`;
            const dataGetResponse = yield this.httpClient.service.get(dataGetURL);
            return dataGetResponse.data.data;
        });
    }
    updateUserLayerState(userId, scanId, scanState) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataUpdateURL = `/users/${userId}/preferences/scans/${scanId}/layers`;
            const dataUpdateResponse = yield this.httpClient.service.patch(dataUpdateURL, scanState);
            return dataUpdateResponse.data.data;
        });
    }
    getUserSettings(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataGetURL = `/users/${userId}/preferences/settings`;
            const dataGetResponse = yield this.httpClient.service.get(dataGetURL);
            return dataGetResponse.data.data;
        });
    }
    updateUserSettings(userId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataUpdateURL = `/users/${userId}/preferences/settings`;
            const dataUpdateResponse = yield this.httpClient.service.patch(dataUpdateURL, data);
            return dataUpdateResponse.data;
        });
    }
    getOrganizations() {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/organizations`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    getOrganization(orgId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/organizations/${orgId}`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    getRole(roleId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/roles/${roleId}`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    getRoles() {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/roles`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    updateScan(scan) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataUpdateURL = `/scans/${scan.id}`;
            const dataUpdateResponse = yield this.httpClient.service.patch(dataUpdateURL, scan);
            return dataUpdateResponse.data;
        });
    }
    fetchIDIcsv(scanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/scans/${scanId}/csv/idi`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    updateOrganization(org) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataUpdateURL = `/organizations/${org.id}`;
            const dataUpdateResponse = yield this.httpClient.service.patch(dataUpdateURL, org);
            return dataUpdateResponse.data;
        });
    }
    createOrganization(org) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataCreateURL = `/organizations`;
            const dataCreateResponse = yield this.httpClient.service.post(dataCreateURL, org);
            return dataCreateResponse.data;
        });
    }
    fetchMembershipsByUsers(uid) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/users/${uid}/memberships/`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    updateMembership(membership) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataPatchURL = `/memberships/${membership.id}`;
            const dataPatchResponse = yield this.httpClient.service.patch(dataPatchURL, membership);
            return dataPatchResponse.data.data;
        });
    }
    getOrganizationScans(organizationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/organizations/${organizationId}/scans`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    getTOS() {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = "/tos";
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    getNotifications() {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = "/notifications";
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    createScan(scan) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataPostURL = "/scans";
            const dataPostResponse = yield this.httpClient.service.post(dataPostURL, scan);
            return dataPostResponse.data.data;
        });
    }
    createLayer(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataPostURL = "/layers";
            const dataPostResponse = yield this.httpClient.service.post(dataPostURL, layer);
            return dataPostResponse.data.data;
        });
    }
    updateLayer(layer) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataPatchURL = `/layers/${layer.id}`;
            const dataPatchResponse = yield this.httpClient.service.patch(dataPatchURL, layer);
            return dataPatchResponse.data.data;
        });
    }
    getOrganizationEmbeddedMaps(organizationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/organizations/${organizationId}/embedded-maps`;
            const dataFetchResoponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResoponse.data.data;
        });
    }
    updateMap(map) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataUpdateURL = `/embedded-maps/${map.id}`;
            const dataUpdateResponse = yield this.httpClient.service.patch(dataUpdateURL, map);
            return dataUpdateResponse.data;
        });
    }
    createMap(map) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataCreateURL = `/embedded-maps`;
            const dataCreateResponse = yield this.httpClient.service.post(dataCreateURL, map);
            return dataCreateResponse.data;
        });
    }
    createFreeTrial(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataCreateURL = "/free-trial";
            const dataCreateResponse = yield this.httpClient.service.post(dataCreateURL, data, {
                noAuth: true,
            });
            return dataCreateResponse.data;
        });
    }
    createRoadSense(data) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataCreateURL = "/road-sense";
            const dataCreateResponse = yield this.httpClient.service.post(dataCreateURL, data, {
                noAuth: true,
            });
            return dataCreateResponse.data;
        });
    }
    downloadRoadSense() {
        return __awaiter(this, void 0, void 0, function* () {
            const apiURL = `/download-roadsense`;
            const dataUpdateResponse = yield this.httpClient.service.post(apiURL);
            return dataUpdateResponse.data;
        });
    }
    getAnnotatedFeature(featureUID) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/annotated-features/${featureUID}`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    createAnnotatedFeature(annotatedFeature) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataCreateURL = `/annotated-features`;
            const dataCreateResponse = yield this.httpClient.service.post(dataCreateURL, annotatedFeature);
            return dataCreateResponse.data;
        });
    }
    updateAnnotatedFeature(annotatedFeature) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataCreateURL = `/annotated-features/${annotatedFeature.id}`;
            const dataCreateResponse = yield this.httpClient.service.patch(dataCreateURL, annotatedFeature);
            return dataCreateResponse.data;
        });
    }
    addAnnotatedField(addedField) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataCreateURL = `/scans/${addedField.scanId}/annotated-fields`;
            const dataCreateResponse = yield this.httpClient.service.patch(dataCreateURL, addedField);
            return dataCreateResponse.data;
        });
    }
    deleteAnnotatedField(deletedField) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line max-len
            const dataDeleteURL = `/scans/${deletedField.scanId}/annotated-fields/${deletedField.annotatedFieldName}`;
            // The axios delete signature is not the same as the get or patch. The body
            // is the value of the `data` key in the object.
            const dataDeleteResponse = yield this.httpClient.service.delete(dataDeleteURL, {
                data: deletedField,
            });
            return dataDeleteResponse.data;
        });
    }
    addAnnotatedFieldOption(addedOption) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataCreateURL = `/scans/${addedOption.scanId}/annotated-fields/options`;
            const dataCreateResponse = yield this.httpClient.service.patch(dataCreateURL, addedOption);
            return dataCreateResponse.data;
        });
    }
    deleteAnnotatedFieldOption(deletedOption) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line max-len
            const dataCreateURL = `/scans/${deletedOption.scanId}/annotated-fields/${deletedOption.annotatedFieldName}/options/${deletedOption.optionId}`;
            const dataCreateResponse = yield this.httpClient.service.delete(dataCreateURL, {
                data: deletedOption,
            });
            return dataCreateResponse.data;
        });
    }
    getAnnotationFields(scanId) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataCreateURL = `/scans/${scanId}/annotated-fields`;
            const dataCreateResponse = yield this.httpClient.service.get(dataCreateURL);
            return dataCreateResponse.data.data;
        });
    }
    getRoadBoticsOrganization() {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/organizations/roadbotics`;
            const dataFetchResponse = yield this.httpClient.service.get(dataFetchURL);
            return dataFetchResponse.data.data;
        });
    }
    postIdTokenToSessionLogin(idToken, csrfToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `/authenticate/login`;
            const dataFetchResponse = yield this.httpClient.service.post(dataFetchURL, {
                idToken,
                csrfToken,
            }, {
                withCredentials: true,
            });
            return dataFetchResponse;
        });
    }
    validateSessionToken() {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `${this.roadwayAPIBaseURL}/authenticate/validate`;
            // have to use axios directly here since we do not have a valid user token yet for the httpclient
            const dataFetchResponse = yield axios.post(dataFetchURL, {}, {
                withCredentials: true,
            });
            yield this.firebase
                .auth()
                .signInWithCustomToken(dataFetchResponse.data.data.customToken);
            return dataFetchResponse;
        });
    }
    logoutSession() {
        return __awaiter(this, void 0, void 0, function* () {
            const dataFetchURL = `${this.roadwayAPIBaseURL}/authenticate/logout`;
            // have to use axios directly here since we do not have a valid user token yet for the httpclient
            return yield axios.post(dataFetchURL, {}, {
                withCredentials: true,
            });
        });
    }
    resetAuthorizationHeaderToken() {
        this.httpClient.updateDefaultAuthorizationHeader(undefined);
    }
    submitHubSpotForm(firstName, lastName, email, url, hubspotutk, portalId, formId, organization) {
        const data = createHubSpotData(firstName, lastName, email, url, hubspotutk, organization);
        return axios.post(`https://api.hsforms.com/submissions/v3/integration/submit/${portalId}/${formId}`, data);
    }
}
export default RBAPI;
export { MappyAPI, VeritasAPI };
